class ApiHost{
    static get(){
        if(process.env.NODE_ENV === 'testing'){
            return process.env.DOMAIN_CREDAMO_API_URL       
        }
        return `${ window.location.origin }/v1`
    }

    static getDomain(){
        if(process.env.NODE_ENV === 'testing'){
            return 'nankai.credamo.cn'    
        }else{
            return window.location.host
        }
    }
}

export {
    ApiHost
}


// WEBPACK FOOTER //
// ./src/config/api-host.js